module.exports = __webpack_public_path__ + "img/ground.67d8dcb1.jpg";